import React, { Fragment } from 'react';
import numeral from 'numeral';

import {
    Typography,
    Box,
    Grid,
    colors,
    makeStyles
} from '@material-ui/core';



const useStyles = makeStyles((theme) => ({
    root: {

    },
    labelvalue: {
        padding: 17
    },
    labelvaluefail: {
        padding: 17,
        backgroundColor: colors.red[600],
        color: "white",
        borderRadius: 6
    },
    instrumenticon: {
        padding: 2,
        width: 50,
        height: 50
    },
    chipgreen: {
        backgroundColor: colors.green[400],
        width: 85,
        margin: 1
    },
    chipblue: {
        backgroundColor: colors.blue[400],
        width: 85,
        margin: 1
    }

}));


const INST05 = ({ instrument, message, event, instruments, alarm, device, schedules, commands, sendCommands }) => {

    const classes = useStyles();

    const isAlarmedField = (field, alarm) => {
        if (alarm === undefined || field === undefined) {
            return false;
        }
        if (Object.keys(alarm).length != 0) {
            var count = 0;
            alarm.fails.map((fail) => {
                if (fail.field.id == field._id && fail.type === 'fail') {
                    count++;
                }
            })
            return (count > 0);
        }
        return false
    }

    return (
        <Fragment>
            <Box padding={1} margin={instrument.border} border={instrument.border} borderRadius={instrument.radius}
                borderColor={colors.grey[300]}>

                <Grid
                    container
                    direction="row"
                    justify="center"
                    alignItems="center"
                >
                    <Grid item xs="auto" >
                        <Typography color="textSecondary" variant="h5" className={classes.labelvalue}>
                            <b>{instrument.label}</b>
                        </Typography>
                    </Grid>
                    <Grid item xs="auto" >
                        {instrument.inputfields.map((infield, index) => (
                            message.inputs.map((field, index) => (
                                (field.order === infield.fieldindex) ? (

                                    isAlarmedField(field, alarm) ? (
                                        <Typography color="primary" variant="h5" className={classes.labelvaluefail}  >
                                            {numeral(event.data[field.order]).format(field.format) + ` ` + field.sufix}
                                        </Typography>

                                    ) : (
                                        <Typography color="primary" variant="h5" className={classes.labelvalue}  >
                                            {numeral(event.data[field.order]).format(field.format) + ` ` + field.sufix}
                                        </Typography>

                                    )

                                ) : (<div></div>)
                            ))
                        ))}
                    </Grid>
                </Grid>
            </Box>
        </Fragment >
    );

}

export default INST05;